document.addEventListener("DOMContentLoaded", () => {
	const loadMoreButton = document.querySelector("#load-more");
	const filterLatest = document.querySelector("#filter-latest");
	const filterTop = document.querySelector("#filter-top");
	const container = document.querySelector("#posts-list, .author-posts-list");
	const status = document.querySelector("#load-more-status");

	const announce = (message) => {
		if (status) status.textContent = message;
	};

	const setBusy = (busy) => {
		if (!loadMoreButton) return;
		loadMoreButton.disabled = busy;
		loadMoreButton.setAttribute("aria-busy", String(busy));
		container?.setAttribute("aria-busy", String(busy));
	};

	const setComplete = () => {
		if (!loadMoreButton) return;
		loadMoreButton.textContent = "All articles loaded";
		loadMoreButton.disabled = true;
		loadMoreButton.removeAttribute("data-next-page");
	};

	const applyTopFilter = () => {
		if (!container) return;
		container.querySelectorAll("article").forEach((post) => {
			post.hidden = !post.classList.contains("featured");
		});
		if (loadMoreButton) loadMoreButton.hidden = true;
	};

	const applyLatestFilter = () => {
		if (!container) return;
		container.querySelectorAll("article").forEach((post) => {
			post.hidden = false;
		});
		if (loadMoreButton) loadMoreButton.hidden = false;
	};

	if (loadMoreButton && container) {
		loadMoreButton.addEventListener("click", async () => {
			const nextLink = document.querySelector('link[rel="next"]');
			const nextPage = loadMoreButton.getAttribute("data-next-page");
			const currentPath = window.location.pathname
				.replace(/\/page\/\d+\/?$/, "")
				.replace(/\/$/, "");
			const url =
				nextLink?.href ||
				(nextPage ? `${currentPath}/page/${nextPage}/` : null);

			if (!url) {
				setComplete();
				announce("All articles are loaded.");
				return;
			}

			loadMoreButton.textContent = "Loading articles…";
			setBusy(true);
			announce("Loading more articles.");

			try {
				const response = await fetch(url);
				if (!response.ok)
					throw new Error(`Request failed with status ${response.status}`);

				const documentFragment = new DOMParser().parseFromString(
					await response.text(),
					"text/html",
				);
				const newPosts = documentFragment.querySelectorAll(
					"#posts-list > article, .author-posts-list > article",
				);
				if (!newPosts.length)
					throw new Error("The next page did not contain any articles");

				newPosts.forEach((post) => container.append(post));
				announce(
					`${newPosts.length} more ${newPosts.length === 1 ? "article" : "articles"} loaded.`,
				);

				const newNextLink = documentFragment.querySelector('link[rel="next"]');
				if (newNextLink) {
					if (nextLink) nextLink.href = newNextLink.href;
					else {
						const link = document.createElement("link");
						link.rel = "next";
						link.href = newNextLink.href;
						document.head.append(link);
					}

					const parsedPage = Number.parseInt(nextPage || "", 10);
					if (Number.isFinite(parsedPage)) {
						loadMoreButton.setAttribute(
							"data-next-page",
							String(parsedPage + 1),
						);
					}
					loadMoreButton.textContent = "Load more";
					setBusy(false);
				} else {
					nextLink?.remove();
					setComplete();
				}

				if (filterTop?.classList.contains("is-active")) applyTopFilter();
			} catch {
				loadMoreButton.textContent = "Try again";
				setBusy(false);
				announce(
					"Articles could not load. Check your connection, then try again.",
				);
			}
		});
	}

	if (filterLatest && filterTop) {
		const setActiveButton = (activeButton, inactiveButton) => {
			activeButton.classList.add("is-active");
			activeButton.setAttribute("aria-pressed", "true");
			inactiveButton.classList.remove("is-active");
			inactiveButton.setAttribute("aria-pressed", "false");
		};

		filterTop.addEventListener("click", () => {
			setActiveButton(filterTop, filterLatest);
			applyTopFilter();
		});

		filterLatest.addEventListener("click", () => {
			setActiveButton(filterLatest, filterTop);
			applyLatestFilter();
		});
	}
});
